import { useTranslation } from 'react-i18next';

// UB18 — visible only on focus, hides off-screen by default. The target
// anchor `#main-content` lives on each layout's <main>.
export function SkipToContent() {
  const { t } = useTranslation();
  return (
    <a className="skip-to-content" href="#main-content">
      {t('skip')}
    </a>
  );
}
